export const DateFormat = {
  DEFAULT: 'YYYY-MM-DD HH:mm:ss',
  DISPLAY_DATETIME: 'YYYY.MM.DD. HH:mm',
  DISPLAY_DATE: 'YYYY.MM.DD.',
}
